import React from 'react'
import Button from '../elements/Button'

export const MenuItem = ({to, onClick, icon, children, disabled, active, ...rest}) => {
    return(
        <Button variant="inherit" to={to} navLink active={active} onClick={onClick} disabled={disabled} children={children} icon ={icon} className="menu-btn"/>
    )    
}
 
